














































































































































































































































































































































































const BatchAllocation = () => import("./components/batchAllocation.vue");
import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index";
import { ticketClient } from "@/api/index";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { BatchRecycleTicketReq, Bool } from "@/pbjs/external/ticket/ticket_pb";
@Component({
  name: "orderReview",
  components: { BatchAllocation },
})
export default class orderReview extends Vue {
  @Provide() private searchForm: any = {
    ticketid: null, //Ticket ID
    planid: null, //借款 ID
    loanValue: null, //首复贷
    orderstatus: null, //工单状态
    auditresult: null, //审核结果
    ordertype: null, //工单类型
    createTimeRange: [],
    completeTimeRange: [],
    closeTimeRange: [],
    assignTimeRange: [],
    staffid: null, // 员工ID
    auditor: null, //审核员
    pageSize: null,
    mobile: null
  };
  // @Provide() private isSelectedIdSearch: boolean = false;
  @Provide() private ticketOrdertype: string = ""
  @Provide() private itemid: string = ""; // 工单类型
  @Provide() private resultData: any = [];
  @Provide() private visible: boolean = false;

  @Provide() private handleTime: any = []; //信审工单处理时间
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private isLoanding: boolean = false;
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => {},
    start: "00:00",
    step: "00:10",
    end: "23: 50",
  };

  @Provide() private reloanOptions: any = [
    { name: "v0707.FirstLoan", value: Bool.BOOL_NO },
    { name: "v0707.Reloan", value: Bool.BOOL_YES },
  ];
  @Provide() private parameterData: any = []; //工单类型
  @Provide() private orderstatusOptions: any = []; //工单状态
  @Provide() private auditresultOptions: any = []; //审核状态
  @Provide() private showBatchAllocation: boolean = false; //展示批量分配弹窗
  @Provide() private ticketSelection: any = []; //被选中的数组
  @Provide() private selectedTicketIds: number[] = []; //被选中的TicketId
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private isDisabled: any = true; // select是否可点击
  @Provide() private applist: any = []; // select是否可点击
  private created() {
    // 获取信审工单列表参数
    this.getTicketListParam();
    // this.getVerifyTicketList(); //信审工单列表数据
  }
  private changePage(e) {
    this.pageSize = e

    this.handleSizeChange(e || 20)
  }
  //  点击批量分配或者分配
  private massAssign(type: number, data: any) {
    this.ticketOrdertype = type === 0 ? ''+data.ticket.itemid: "";
    if(this.searchForm.ordertype || this.ticketOrdertype) {
      if (this.searchForm.ordertype == null) {
        this.$message.error("Please choose the order classify");
      } else {
        this.itemid = this.searchForm.ordertype;
        this.showBatchAllocation = true;
        this.selectedTicketIds = [];
        if (data !== "") {
          this.selectedTicketIds.push(data.ticket.id);
        } else {
          this.ticketSelection.forEach((item: any) => {
            this.selectedTicketIds.push(item.ticket.id);
          });
        }
      }
    } else {
      this.$message.error("Pless choose the order classify!");
    }
  }
  // 批量回收
  private massRecyle() {
    if (this.searchForm.ordertype) {
      this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
        confirmButtonText: this.$tc("authority.ok"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning",
      })
      .then(() => {
        this.findSelectedIds();
        this.batchRecycleTicket();
      })
      .catch(() => {});
    } else {
      this.$message.error("Pls choose the order classify");
    }
  }
  private findSelectedIds() {
    this.selectedTicketIds = [];
    this.ticketSelection.forEach((item: any) => {
      this.selectedTicketIds.push(item?.ticket?.id);
    });
  }
  private batchRecycleTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    }); // 转换类型为string array
    let request: any = new BatchRecycleTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.searchForm.ordertype);
    request.setTicketidsList(arr);
    ticketClient.batchRecycleTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchRecycleTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private batchRecycleTicketFuc(data: any) {
    this.getVerifyTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  // 批量回收 end
  // 隐藏添加弹窗
  private returnRiskReport() {
    this.showBatchAllocation = false;
    this.getVerifyTicketList();
  }
  // 处理工单
  private handleOrder(row: any) {
    let routeData = this.$router.resolve({
      path: "/auditDetail",
      query: {
        orderid: row.ticket.orderid,
        ticketitemid: row.ticket.itemid, //工单类型
        ticketid: row.ticket.id,
        customerid: row.ticket.customerid,
        assignuid: row.ticket.assignuid,
        status:row.ticket.status,
        isAudi:'false',
        appname: row.appname
      },
    });
    window.open(routeData.href, "_blank");
  }
  // 当选择项发生变化时
  private handleSelectionChange(val: any) {
    this.ticketSelection = val;
    if (val.length > 0) {
      this.isDisabled = false;
    }
  }
  private showOrHideSearchRegion() {
    this.isShowSearchRegion = !this.isShowSearchRegion;
  }
  //  lee 清除操作
  private clearFormAction() {
    (this.$refs["searchForm"] as any).resetFields();
    this.searchForm.pickDate = [];
    this.searchForm.loanValue = ""; //首复贷
    this.searchForm.orderstatus = ""; //工单状态
    this.searchForm.auditresult = ""; //审核
    this.searchForm.ordertype = "";
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    this.getVerifyTicketList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getVerifyTicketList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getVerifyTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getVerifyTicketList();
  }
  // 获取下拉框参数
  private async getTicketListParam() {
    const {
      getVerifyTicketListParamReq,
      getVerifyTicketListParamRequest,
    }: any = await import("@/request/getVerifyOrderData");
    let res = await getVerifyTicketListParamRequest.handleHttp(
      getVerifyTicketListParamReq(),
      this
    );
    if (res && res.right) {
      this.parameterData = res.ticketitemList;
      this.orderstatusOptions = res.ticketstatusList;
      this.auditresultOptions = res.verifyresultmapMap;
      this.applist = res.applist
    }
  }
  //  必传参数处理
  private dwGetTicketListReqParamsNeed() {
    if (this.searchForm.ticketid || this.searchForm.planid || this.searchForm.ordertype || this.searchForm.mobile) {
      return true;
    } else {
      // 请确保您至少输入了工单ID/借款ID/工单分类中的任意一个
      this.$message.error(
        this.$tc(
          "pls make sure you’ve provided one of Ticket ID/Loan ID/Ticket category at least"
        )
      );
      return false;
    }
  }
  // 搜索框信息
  private searchAction(): any { 
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      ticketid: this.searchForm.ticketid ? +this.searchForm.ticketid : null, //Ticket ID
      planid: this.searchForm.planid, //借款 ID
      loanValue: this.searchForm.loanValue ? +this.searchForm.loanValue : 0, //首复贷
      orderstatus: this.searchForm.orderstatus.toString(), //工单状态
      auditresult: this.searchForm.auditresult ? +this.searchForm.auditresult : null, //审核结果
      ordertype: this.searchForm.ordertype ? +this.searchForm.ordertype : null, //工单类型
      staffid: this.searchForm.staffid ? +this.searchForm.staffid : null, // 员工ID
      auditor: this.searchForm.auditor, //审核员
      appname: this.searchForm.appname.toString(),
      mobile: this.searchForm.mobile,
    };
    if (this.searchForm.createTimeRange && this.searchForm.createTimeRange.length > 0) {
      _arg.createtime =
        timeFormat(this.searchForm.createTimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.createTimeRange[1].getTime());
    }
    if (
      this.searchForm.completeTimeRange &&
      this.searchForm.completeTimeRange.length > 0
    ) {
      _arg.completetime =
        timeFormat(this.searchForm.completeTimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.completeTimeRange[1].getTime());
    }
    if (this.searchForm.closeTimeRange && this.searchForm.closeTimeRange.length > 0) {
      _arg.closetime =
        timeFormat(this.searchForm.closeTimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.closeTimeRange[1].getTime());
    }
    if (this.searchForm.assignTimeRange && this.searchForm.assignTimeRange.length > 0) {
      _arg.assigntime =
        timeFormat(this.searchForm.assignTimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.assignTimeRange[1].getTime());
    }
    return _arg;
  }
  // 查询列表
  private async getVerifyTicketList() {
     let _arg: any = this.searchAction();
     
    if (this.dwGetTicketListReqParamsNeed()) {
      let _arg: any = this.searchAction();
      this.isLoanding = true;
      const { getVerifyTicketListReq, getVerifyTicketListRequest }: any = await import(
        "@/request/getVerifyOrderData"
      );
      
      let res = await getVerifyTicketListRequest.handleHttp(
        getVerifyTicketListReq(_arg),
        this
      );
      this.isLoanding = res ? res.loading : false;
       
      if (res && res.right) {
        sessionStorage.setItem("orderList",JSON.stringify(res))
        // this.isSelectedIdSearch = this.searchForm.ordertype ? true : false;
        this.pagerCount = res.pageout.total;
        this.resultData = res.listList && res.listList.length > 0 ? res.listList : [];
        this.resultData.forEach((data: any) => {
          //  0 1 为首贷，1为复贷
          data.ticket.isreloan =
            data.ticket.isreloan === 1
              ? this.$t("v0707.Reloan")
              : this.$t("v0707.FirstLoan");
          data.ticket.ctime = data.ticket.ctime && timeFormat(data.ticket.ctime);
          data.ticket.assigntime =
            data.ticket.assigntime && timeFormat(data.ticket.assigntime);
          data.ticket.completetime =
            data.ticket.completetime && timeFormat(data.ticket.completetime);
          // 工单处理时间
          data.ticket.lasthandletime =
            data.ticket.lasthandletime && timeFormat(data.ticket.lasthandletime);
          // 部分完成时间
          data.ticket.partialcompletetime =
            data.ticket.partialcompletetime &&
            timeFormat(data.ticket.partialcompletetime);
             // 工单处理时间
          data.ticket.starttime =
            data.ticket.starttime &&
            timeFormat(data.ticket.starttime);
          // 关闭时间
          data.ticket.closetime =
            data.ticket.closetime && timeFormat(data.ticket.closetime);
          this.$set(data.ticket, "visible", this.visible);
          let closeDisabled = false;
          if (data.ticket.status === 5) {
            closeDisabled = true;
          }
          this.$set(data.ticket, "closeDisabled", closeDisabled);
        });
      } else {
        this.isLoanding = false;
      }
    }
  }
  // 关闭
  private closeTicket(row: any) {
    this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
      confirmButtonText: this.$tc("authority.ok"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning",
    }).then(() => {
      this.doCloseTicket(row);
    });
  }
  private async doCloseTicket(row: any) {
    let _arg: any = {
      ticketid: row.ticket.id, //Ticket ID
      ordertype: row.ticket.itemid, //工单类型
    };
    const { closeTicketReq, closeTicketRequest }: any = await import(
      "@/request/getVerifyOrderData"
    );
    let res = await closeTicketRequest.handleHttp(closeTicketReq(_arg), this);

    if (res && res.right) {
      this.$message({
        type: "success",
        message: "Success!",
      });
    }
    this.getVerifyTicketList();
  }
  private fixLastTime(time) {
    if(!time) {
      return 0
    }
    // {{scope.row.lasthandletime ? ((new Date().getTime() - new Date(scope.row.lasthandletime).getTime())/1000/60/60).toFixed(1): 0}} {{$t('ticket.Hour')}}
    let startTime = new Date(time).getTime(); // 开始时间
    let endTime = new Date().getTime(); // 结束时间
    let usedTime = endTime - startTime; // 相差的毫秒数
    let days = Math.floor(usedTime / (24 * 3600 * 1000)); // 计算出天数
    let leavel = usedTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
    let hours = Math.floor(leavel / (3600 * 1000)); // 计算剩余的小时数
    let leavel2 = leavel % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
    let minutes = Math.floor(leavel2 / (60 * 1000)); // 计算剩余的分钟数
    return (days *24*60 + hours*60 + minutes) + ' '+ this.$t('ticket.MIN');
  }
  // 获取信审工单处理时间
  private async getVerifyTicketHandleTime(data: any) {
    this.handleTime = [];
    data.ticket.visible = true;
    if (data.ticket.visible) {
      let _arg: any = {
        itemid: data.ticket.itemid, //工单类型
        orderid: data.ticket.orderid, //借款id
        ticketid: data.ticket.id, // Ticket ID
      };
      const {
        getVerifyTicketHandleTimeReq,
        getVerifyTicketHandleTimeRequest,
      }: any = await import("@/request/getVerifyOrderData");
      let res = await getVerifyTicketHandleTimeRequest.handleHttp(
        getVerifyTicketHandleTimeReq(_arg),
        this
      );
      if (res && res.right) {
        let timeList: any = [];
        if (res.handletimesList && res.handletimesList.length > 0) {
          res.handletimesList.forEach((item: any) => {
            return timeList.push(timeFormat(item));
          });
          data.ticket.visible = false;
          this.handleTime = timeList;
        }
      }
    } else {
      this.handleTime = [];
    }
  }
}
